<template>
  <div class="tools-suggestions-display">
    <div v-if="headerText" class="suggestions-header">
      <strong>{{ headerText }}</strong>
    </div>
    <div class="tools-suggestions-list">
      <ToolSuggestionCard
        v-for="tool in tools"
        :key="tool.id || tool.tool_id"
        :tool="tool"
        @select="handleToolSelect"
      />
    </div>
  </div>
</template>

<script>
import ToolSuggestionCard from './ToolSuggestionCard.vue';

export default {
  name: 'ToolsSuggestionsDisplay',
  components: {
    ToolSuggestionCard,
  },
  props: {
    tools: {
      type: Array,
      required: true,
      // Array of full tool objects from suggest_tools tool_result
      // Format: { id, name, description, score, explanation, use_case, location, url }
      // or legacy: { tool_id, score, explanation }
    },
    headerText: {
      type: String,
      default: 'Here are some tools that might help:',
    },
  },
  methods: {
    handleToolSelect(tool) {
      this.$emit('select', tool);
    },
  },
};
</script>

<style scoped lang="scss">
.tools-suggestions-display {
  margin-top: 12px;
  padding-top: 12px;
  border-top: 1px solid rgba(0, 0, 0, 0.1);
}

.suggestions-header {
  font-size: 0.9rem;
  color: var(--darkColor);
  margin-bottom: 12px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.tools-suggestions-list {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}

@media (max-width: 768px) {
  .tools-suggestions-display {
    padding-top: 8px;
    margin-top: 8px;
  }

  .suggestions-header {
    font-size: 0.85rem;
  }
}
</style>
